/**
 * Economic shipping zones for the Item Location facet.
 * Aligned with assets/shipping-estimator.js EU_ISO (customs union, not "Europe").
 * Country labels match Algolia meta.custom.shipping_country facet values (EN).
 */
(function (window) {
  'use strict';

  // Same 27 as shipping-estimator EU_ISO — English names as indexed in Algolia.
  var EU_COUNTRIES = [
    'Austria',
    'Belgium',
    'Bulgaria',
    'Croatia',
    'Cyprus',
    'Czech Republic',
    'Czechia',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Greece',
    'Hungary',
    'Ireland',
    'Italy',
    'Latvia',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Netherlands',
    'Poland',
    'Portugal',
    'Romania',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Sweden',
  ];

  var US_COUNTRIES = [
    'United States',
    'United States of America',
    'USA',
  ];

  var UK_COUNTRIES = [
    'United Kingdom',
    'Great Britain',
    'England',
    'Scotland',
    'Wales',
    'Northern Ireland',
  ];

  var ZONES = [
    {
      id: 'eu',
      label: 'European Union',
      countries: EU_COUNTRIES,
    },
    {
      id: 'us',
      label: 'United States',
      countries: US_COUNTRIES,
    },
    {
      id: 'uk',
      label: 'United Kingdom',
      countries: UK_COUNTRIES,
    },
    {
      id: 'other',
      label: 'Other',
      countries: null, // catch-all
    },
  ];

  var countryToZone = Object.create(null);

  EU_COUNTRIES.forEach(function (name) {
    countryToZone[normalizeCountry(name)] = 'eu';
  });
  US_COUNTRIES.forEach(function (name) {
    countryToZone[normalizeCountry(name)] = 'us';
  });
  UK_COUNTRIES.forEach(function (name) {
    countryToZone[normalizeCountry(name)] = 'uk';
  });

  function normalizeCountry(name) {
    return String(name || '')
      .replace(/[\[\]"']/g, '')
      .trim()
      .toLowerCase();
  }

  function getZoneIdForCountry(countryName) {
    return countryToZone[normalizeCountry(countryName)] || 'other';
  }

  /**
   * Visitor economic zone from Shopify market region / mapping.
   * @param {string} marketRegion e.g. FR, US, GB
   * @param {{ market?: string, regions?: string[] }|null} marketEntry
   * @returns {'eu'|'us'|'uk'|null}
   */
  function getVisitorZoneId(marketRegion, marketEntry) {
    var region = String(marketRegion || '').toUpperCase();
    var marketName = (marketEntry && marketEntry.market) || '';
    var regions = (marketEntry && marketEntry.regions) || [];

    if (
      region === 'US' ||
      marketName === 'United States' ||
      regions.indexOf('US') >= 0
    ) {
      return 'us';
    }
    if (
      region === 'GB' ||
      region === 'UK' ||
      marketName === 'United Kingdom' ||
      regions.indexOf('GB') >= 0 ||
      regions.indexOf('UK') >= 0
    ) {
      return 'uk';
    }
    // France + other EU markets → European Union
    if (
      marketName === 'France' ||
      regions.indexOf('FR') >= 0 ||
      region === 'FR' ||
      EU_ISO_HINT.indexOf(region) >= 0
    ) {
      return 'eu';
    }
    return null;
  }

  // ISO hints for market.region when not FR/US/UK named markets
  var EU_ISO_HINT = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
    'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  ];

  /**
   * Ordered zone ids: visitor zone first (if any), then the rest, Other last.
   */
  function getOrderedZoneIds(visitorZoneId) {
    var ids = ZONES.map(function (z) { return z.id; });
    if (!visitorZoneId || ids.indexOf(visitorZoneId) < 0) return ids;
    return [visitorZoneId].concat(
      ids.filter(function (id) { return id !== visitorZoneId; })
    );
  }

  function getZoneById(zoneId) {
    for (var i = 0; i < ZONES.length; i++) {
      if (ZONES[i].id === zoneId) return ZONES[i];
    }
    return null;
  }

  window.OblistShippingZones = {
    ZONES: ZONES,
    normalizeCountry: normalizeCountry,
    getZoneIdForCountry: getZoneIdForCountry,
    getVisitorZoneId: getVisitorZoneId,
    getOrderedZoneIds: getOrderedZoneIds,
    getZoneById: getZoneById,
  };
})(window);
